export const translations = {
    'PTBR': {
        mainTitle: 'Aprenda até 10x mais rápido com IA',
        subTitle: 'A LearnArez é uma plataforma de aprendizado que utiliza inteligência artificial para personalizar o conteúdo de acordo com o seu perfil, criando sessões únicas, flashcards e testes sob medida, ajudando você a aprender de forma mais eficiente e rápida.',
        ctaButton: 'Comece Grátis',
        ctaButtonLogin: 'Entrar',
        ctaButtonRegister: 'Registrar',
        advantages: [
            {
                title: "Sessões de estudo personalizadas",
                description: "Você escolhe os temas, e a IA cria sessões de estudo únicas adaptadas às suas necessidades, otimizando seu processo de aprendizado."
            },
            {
                title: "Criação fácil de flashcards",
                description: "Crie flashcards rapidamente e de forma intuitiva, exatamente como você precisa, com a ajuda da IA."
            },
            {
                title: "Testes personalizados para você",
                description: "A IA gera testes personalizados com base nos temas que você deseja estudar e no seu nível de conhecimento atual, garantindo que você sempre aprenda de forma eficaz."
            },
            {
                title: "Organização completa dos estudos",
                description: "Tenha controle total sobre o que, quando e como estudar sem se perder em excesso de informações."
            },
            {
                title: "Aprendizado prático e objetivo",
                description: "Sem enrolação: estude exatamente o que importa, totalmente focado no seu progresso."
            },
            {
                title: "Interface limpa, simples e intuitiva",
                description: "Fácil de usar, com design bonito e feito para você focar no que realmente importa: aprender."
            },
            {
                title: "Acesso de qualquer lugar",
                description: "Estude a qualquer hora, de qualquer dispositivo, 100% online."
            },
            {
                title: "Aprenda no seu ritmo, do seu jeito",
                description: "Você escolhe os temas, define suas metas e a IA ajuda a guiar sua jornada de aprendizado."
            }
        ],
        persuasiveInfoOne: {
            title: "Aprender com inteligência é a nova vantagem competitiva",
            text: "A maioria das plataformas oferece conteúdo.\nA LearnArez entrega progresso real.\nCom tecnologia de ponta e inteligência artificial aplicada, sua rotina de estudos se transforma em crescimento mensurável. Diga adeus aos métodos genéricos, foco disperso e excesso de informações. Na LearnArez, cada sessão é otimizada para maximizar resultados, focando no que realmente importa: aprender com eficiência e consistência."
        },
        persuasiveInfoTwo: {
            title: "Aprendizado estratégico é o que diferencia quem alcança metas",
            text: "Se seu objetivo é apenas consumir conteúdo, há muitas plataformas por aí.\nMas se você quer aprender mais rápido, com clareza e estrutura, a LearnArez é a escolha certa. Nossa plataforma adapta o processo de aprendizado ao seu nível de conhecimento atual, define metas claras, acompanha seu progresso e garante que seu esforço leve a resultados reais. É uma forma mais inteligente de estudar, com propósito, precisão e autonomia."
        },
        frequentlyAskedQuestionsTitle: 'Perguntas Frequentes (FAQ)',
        frequentlyAskedQuestions: [
            {
                question: "O que é a LearnArez?",
                answer: "A LearnArez é uma plataforma de estudos inteligente movida por inteligência artificial. Ela cria sessões de estudo personalizadas, flashcards sob medida e testes adaptativos para ajudar você a aprender até 10x mais rápido."
            },
            {
                question: "Para quem é a LearnArez?",
                answer: "A LearnArez é ideal para aprendizes de qualquer nível, incluindo estudantes, candidatos a exames, profissionais e autodidatas que desejam estudar de forma mais eficiente e organizada."
            },
            {
                question: "Preciso instalar algo para usar a LearnArez?",
                answer: "Não. A LearnArez é totalmente online e funciona diretamente no seu navegador em qualquer dispositivo, seja celular, tablet ou computador."
            },
            {
                question: "A IA realmente personaliza minha experiência de estudo?",
                answer: "Sim. Nossa IA analisa seus objetivos, pontos fortes e fracos para entregar sessões de estudo altamente personalizadas adaptadas às suas necessidades."
            },
            {
                question: "Há um plano gratuito disponível?",
                answer: "Sim. Você pode começar com o plano gratuito, que oferece acesso limitado por dia. Para desbloquear o ilimitado, você pode fazer upgrade para o plano Premium."
            },
            {
                question: "Posso cancelar a qualquer momento?",
                answer: "Sim. Você pode cancelar sua assinatura a qualquer momento com apenas alguns cliques, sem amarras."
            },
            {
                question: "Como funciona o plano Premium?",
                answer: "O plano Premium oferece acesso ilimitado a todos os recursos, incluindo sessões inteligentes, flashcards personalizados, testes adaptativos, acompanhamento de progresso e muito mais."
            }
        ],
        lastCTA: "Ainda preso ao jeito antigo de estudar? É hora de evoluir."
    },
    'EN': {
        mainTitle: 'Learn up to 10x faster with AI',
        subTitle: 'LearnArez is a learning platform that uses artificial intelligence to personalize content according to your profile, creating unique sessions, flashcards, and tailored tests, helping you learn more efficiently and quickly.',
        ctaButton: 'Start for Free',
        ctaButtonLogin: 'Login',
        ctaButtonRegister: 'Register',
        advantages: [
            {
                title: "Personalized study sessions",
                description: "You choose the topics, and the AI creates unique study sessions tailored to your needs, optimizing your learning process."
            },
            {
                title: "Easy flashcard creation",
                description: "Create flashcards quickly and intuitively, exactly the way you need, with AI assistance."
            },
            {
                title: "Custom tests for you",
                description: "AI generates personalized tests based on the topics you want to study and your current knowledge level, ensuring you always learn effectively."
            },
            {
                title: "Complete study organization",
                description: "Have full control over what, when, and how to study without getting lost in information overload."
            },
            {
                title: "Practical and objective learning",
                description: "No fluff: study exactly what matters, fully focused on your progress."
            },
            {
                title: "Clean, simple, and intuitive interface",
                description: "Easy to use, beautifully designed, and made for you to focus on what truly matters: learning."
            },
            {
                title: "Access from anywhere",
                description: "Study anytime, from any device, 100% online."
            },
            {
                title: "Learn at your own pace, your way",
                description: "You choose the topics, set your goals, and the AI helps guide you on your learning journey."
            }
        ],
        persuasiveInfoOne: {
            title: "Learning with intelligence is the new competitive edge",
            text: "Most platforms offer content.\nLearnArez delivers real progress.\nWith cutting-edge technology and applied artificial intelligence, your study routine turns into measurable growth. Say goodbye to generic methods, scattered focus, and information overload. At LearnArez, every session is optimized to maximize results, focusing on what truly matters: learning with efficiency and consistency."
        },
        persuasiveInfoTwo: {
            title: "Strategic learning is what sets goal-achievers apart",
            text: "If your goal is simply to consume content, there are plenty of platforms out there.\nBut if you aim to learn faster, with clarity and structure, LearnArez is the right choice. Our platform adapts the learning process to your current knowledge level, sets clear goals, tracks your progress, and ensures your effort leads to real outcomes. It’s a smarter way to study, with purpose, precision, and autonomy."
        },
        frequentlyAskedQuestionsTitle: 'Frequently Asked Questions (FAQ)',
        frequentlyAskedQuestions: [
            {
                question: "What is LearnArez?",
                answer: "LearnArez is an intelligent study platform powered by artificial intelligence. It creates personalized study sessions, custom flashcards, and adaptive tests to help you learn up to 10x faster."
            },
            {
                question: "Who is LearnArez for?",
                answer: "LearnArez is ideal for learners at any level, including students, exam candidates, professionals, and self-learners who want to study more efficiently and stay organized."
            },
            {
                question: "Do I need to install anything to use LearnArez?",
                answer: "No. LearnArez is fully online and works directly in your browser on any device, phone, tablet, or computer."
            },
            {
                question: "Does the AI really personalize my study experience?",
                answer: "Yes. Our AI analyzes your goals, strengths, and weaknesses to deliver highly personalized study sessions tailored to your needs."
            },
            {
                question: "Is there a free plan available?",
                answer: "Yes. You can start with the free plan, which gives you limited access each day. To unlock unlimited, you can upgrade to the Premium plan."
            },
            {
                question: "Can I cancel anytime?",
                answer: "Yes. You can cancel your subscription at any time with just a few clicks, no strings attached."
            },
            {
                question: "How does the Premium plan work?",
                answer: "The Premium plan gives you unlimited access to all features, including smart sessions, personalized flashcards, adaptive testing, progress tracking, and more."
            }
        ],
        lastCTA: "Still stuck in the old way of studying? It's time to level up."
    }
}

export type LanguageKeys = keyof typeof translations;